export const getRelationLabels = (entry, intl, options = {}) => {
  if (!entry)
    return {
      objectLabel: '',
      subjectLabel: '',
      fallbackObjectLabel: '',
      fallbackSubjectLabel: '',
      primaryLabel: '',
    };

  const humanize = (value = '') =>
    value
      .split(/[_\s]+/)
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');

  const formatRelation = (relation) => {
    if (!relation) return '';
    if (typeof relation === 'string') return relation;
    if (relation?.key) {
      try {
        return intl.formatMessage({
          id: relation.key,
          defaultMessage: relation?.name || humanize(relation.key),
        });
      } catch (error) {
        return relation?.name || relation.key;
      }
    }
    return relation?.name || '';
  };

  const objectField = typeof entry?.object_label === 'string' ? entry.object_label : '';
  const subjectField = typeof entry?.subject_label === 'string' ? entry.subject_label : '';

  let fallbackObjectLabel = formatRelation(entry?.reciprocal_relation);
  let fallbackSubjectLabel = formatRelation(entry?.relation);

  let objectLabel = objectField || fallbackObjectLabel;
  let subjectLabel = subjectField || fallbackSubjectLabel;

  const normalize = (value) => (typeof value === 'string' ? value.trim().toLowerCase() : '');

  const shouldFlip =
    options?.currentUserId &&
    entry?.user?.id &&
    entry.user.id === options.currentUserId &&
    objectField &&
    subjectField &&
    fallbackObjectLabel &&
    fallbackSubjectLabel &&
    normalize(objectField) === normalize(fallbackSubjectLabel) &&
    normalize(subjectField) === normalize(fallbackObjectLabel);

  if (shouldFlip) {
    [objectLabel, subjectLabel] = [subjectLabel, objectLabel];
    [fallbackObjectLabel, fallbackSubjectLabel] = [fallbackSubjectLabel, fallbackObjectLabel];
  }

  const preferSubject = options?.prefer === 'subject';

  const orderedLabels = preferSubject
    ? [subjectLabel, fallbackSubjectLabel, objectLabel, fallbackObjectLabel]
    : [objectLabel, fallbackObjectLabel, subjectLabel, fallbackSubjectLabel];

  const primaryLabel = orderedLabels.find(
    (label) => typeof label === 'string' && label.trim().length > 0,
  );

  return {
    objectLabel,
    subjectLabel,
    fallbackObjectLabel,
    fallbackSubjectLabel,
    primaryLabel: primaryLabel || '',
  };
};
